
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { RootState } from "../../store";
import { debugData } from "../../utils/debugData";
import { isEnvBrowser } from "../../utils/misc";
import { useSocketEventOutsideRequest } from "../../hooks/useSocketEventOutsideRequest";

import { UserState, SET_PLAYERDATA } from "../../reducers/userReducer";
import { PermissionType, PlayerType, HardMoneyState, SET_HOUSEDATA } from "../../reducers/hardmoneyReducer";
import { UIState, SET_activeTab, SET_hidden } from "../../reducers/uiReducer";

import HomeSquares from "./HomeSquares";

import TimeDateList from "./TimeDateList";
import HomeUsage from "./HomeUsage";

const HomePage: React.FC = () => {
    const dispatch = useDispatch();
    const uiData = useSelector((state: RootState) => state.ui);
    const playerData = useSelector((state: RootState) => state.user);
    const hardmoneyData = useSelector((state: RootState) => state.hardmoney);

    const currentPlayer = hardmoneyData.roommates.find(roommate => 
        roommate.UserStateID === playerData.UserState
    );

    if (!currentPlayer) return null;

    return (
        <div 
            //className="fadeInPointFive"
            style={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                boxSizing: "border-box",
                position: "relative",
                //backgroundColor: "orange",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                color: "rgba(255, 255, 255, 0.9)",
            }}
        >
            <div
                style={{
                    width: "50%",
                    paddingRight: "2.5%",
                    height: "100%",
                    //backgroundColor: "gray",
                    boxSizing: "border-box",
                    display: "flex",
                    justifyContent: "flex-start",
                    flexDirection: "column",
                    alignItems: "center",
                    fontWeight: "bold",
                    fontSize: "7.5vh",
                    letterSpacing: 1.25,
                    wordSpacing: 5,
                    textAlign: "left",
                    overflow: "hidden",
                }}
            >
                <TimeDateList/>
                
                <div
                    style={{
                        padding: "1vh 0",
                        borderBottom: "0.2vh solid rgba(90, 90, 90, 0.8)",
                        width: "100%",
                        fontFamily: 'Oswald',
                        fontWeight: "500",
                    }}
                >
                    Welcome, {currentPlayer.playerFirstName}
                    <div

                    >
                        {currentPlayer.playerLastName}
                    </div>
                </div>
                    
                <HomeUsage/>
            </div>
            <div
                style={{
                    width: "47.5%",
                    height: "100%",
                    //backgroundColor: "yellow",
                }}
            >
                <HomeSquares/>
            </div>
        </div>
    );
};

export default HomePage;
